export default "__VITE_ASSET__wWsaKcR___"